import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
    icon: IconProp;
    title: string;
    onClick: () => void;
}

export default function MenuLink({ icon, title, onClick }: Props) {
    return (
        <div
            className="justify-content-between d-flex list-item p-2"
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={() => false}
        >
            <div className="d-flex justify-content-start align-items-center gap-2">
                <FontAwesomeIcon icon={icon} size="xl" />
                <h5 className="mb-0 font-weight-normal font-size-16">
                    {title}
                </h5>
            </div>
            <FontAwesomeIcon icon={faChevronRight} size="xl" />
        </div>
    );
}
